<template>
  <div class="sincere-home">
    <van-nav-bar fixed placeholder class="home-nav" :border="false">
      <template #left>
        <img class="nav-logo" :src="assets.logo" alt="Sincere Love Dating Club">
      </template>
      <template #title>
        <span class="nav-title">Home</span>
      </template>
      <template #right>
        <img
          class="nav-action-icon"
          :src="assets.topVideoIcon"
          alt="Video"
          @click="toRoute('/Video')"
        >
      </template>
    </van-nav-bar>

    <div class="home-body">
      <van-swipe
        class="banner-swipe"
        :autoplay="3000"
        indicator-color="#e6b98a"
      >
        <van-swipe-item
          v-for="(item, index) in heroBanners"
          :key="index"
          class="banner-item"
        >
          <img :src="item.url" :alt="String(index + 1)" class="banner-image" loading="lazy">
        </van-swipe-item>
      </van-swipe>

      <section class="notice-section">
        <div class="notice-container">
          <img :src="assets.noticeIcon" alt="notice" class="notice-icon">
          <div class="notice-marquee">
            <div class="notice-track">
              <span>{{ notice }}</span>
              <span>{{ notice }}</span>
            </div>
          </div>
          <button class="more-btn" @click="toRoute('/Notice')">More</button>
        </div>
      </section>

      <section class="shortcut-section">
        <div class="shortcut-grid">
          <button
            v-for="item in shortcutItems"
            :key="item.title"
            class="shortcut-item"
            @click="toRoute(item.path)"
          >
            <img :src="item.icon" :alt="item.title" class="shortcut-icon" loading="lazy">
            <span>{{ item.title }}</span>
          </button>
        </div>
      </section>

      <section class="section-title">
        <div class="title-left">
          <span class="title-line"></span>
          <span class="title-text">Online companions</span>
        </div>
        <button class="more-btn secondary" @click="toRoute('/Choose')">More</button>
      </section>

      <section class="dating-grid">
        <article
          v-for="item in featuredProfiles"
          :key="item.id"
          class="dating-card"
          @click="toDetail(item.id)"
        >
          <img :src="item.img_url" :alt="item.idText" class="dating-image" loading="lazy">
          <img :src="assets.liveIcon" alt="live" class="live-icon" loading="lazy">
          <div class="verified-tag">{{ item.verifiedText }}</div>

          <div class="card-overlay">
            <div class="card-top">
              <span class="vip-text">{{ item.idText }}</span>
              <span class="location-tag">{{ item.locationText }}</span>
            </div>

            <div class="score-row">
              <img :src="assets.scoreIcon" alt="score" class="score-icon">
              <span class="score-text">{{ item.scoreText }}</span>
            </div>
          </div>
        </article>
      </section>
    </div>

    <button class="customer-service-btn" @click="openSupport()">
      <img src="/img/mine/kefu.png" alt="support">
    </button>
  </div>
</template>

<script>
const TARGET_NOTICE = "Welcome to Sincere Love Dating Club! The world's largest dating platform with over 100,000 members. Here, you can meet high-quality women who are eager to connect with you.";

const FALLBACK_BANNERS = [
  { url: 'https://api.sincereloves.online/storage/20260227/KSh1772247675YkjrbM1.png' },
  { url: 'https://api.sincereloves.online/storage/20260227/MpY1772222051sByWcL1.jpg' },
  { url: 'https://api.sincereloves.online/storage/20260227/mRb1772249401MNjDGI1.jpg' },
  { url: 'https://api.sincereloves.online/storage/20260227/uId1772247213txUhGv1.jpg' },
  { url: 'https://api.sincereloves.online/storage/20260227/dlZ1772246076qulraG1.png' },
  { url: 'https://api.sincereloves.online/storage/20260227/XFJ1772248953vwXzpe1.jpg' }
];

const ASSETS = {
  logo: '/img/login/sincere-logo.png',
  topVideoIcon: '/img/neww/ico_video.png',
  noticeIcon: '/img/neww/notice.png',
  liveIcon: 'https://m.sincereloves.online/icon/lives.gif',
  scoreIcon: '/img/neww/icon_love.png',
  eventsIcon: '/img/neww/ico_vote.png',
  termsIcon: 'https://m.sincereloves.online/icon/icon_activities.png',
  videoIcon: '/img/neww/ico_video.png',
  datingIcon: '/img/neww/ico_vip.png'
};

export default {
  data() {
    return {
      assets: ASSETS,
      notice: TARGET_NOTICE,
      datalist: [],
      shortcutItems: [
        { title: 'Events', path: '/Lottery', icon: ASSETS.eventsIcon },
        { title: 'T&Cs', path: '/Notice', icon: ASSETS.termsIcon },
        { title: 'Video', path: '/Video', icon: ASSETS.videoIcon },
        { title: 'Dating', path: '/Choose', icon: ASSETS.datingIcon }
      ]
    };
  },
  computed: {
    heroBanners() {
      return FALLBACK_BANNERS;
    },
    featuredProfiles() {
      return this.datalist.map((source, index) => {
        const safeSource = source && typeof source === 'object' ? source : {};
        const scoreNumber = Number(safeSource.number);
        return {
          ...safeSource,
          id: safeSource.id || index + 1,
          img_url: this.normalizeAssetUrl(safeSource.img_url || ''),
          idText: (safeSource.home_vip_text || '').trim() || `VIP${safeSource.id || index + 1}`,
          locationText: (safeSource.flag || '').trim() || 'California',
          scoreText: Number.isFinite(scoreNumber) && scoreNumber > 0 ? scoreNumber.toFixed(1) : '9.9',
          verifiedText: (safeSource.home_verified_text || '').trim() || 'Verified'
        };
      });
    }
  },
  methods: {
    toRoute(path) {
      this.$router.push({ path });
    },
    toDetail(id) {
      this.$router.push({ path: '/detail', query: { id } });
    },
    openSupport() {
      const service = this.$store.getters.getBaseInfo || {};
      if (service.iskefu == 1 && service.kefu) {
        window.location.href = service.kefu;
        return;
      }
      this.$router.push('/ServiceOnline');
    },
    normalizeAssetUrl(url) {
      if (!url || typeof url !== 'string') {
        return '';
      }

      const origin = 'https://admin.whtas.me';

      if (/^https?:\/\/127\.0\.0\.1\//.test(url)) {
        return url.replace(/^https?:\/\/127\.0\.0\.1\//, `${origin}/`);
      }

      if (/^https?:\/\/localhost:8081\//.test(url)) {
        return url.replace(/^https?:\/\/localhost:8081\//, `${origin}/`);
      }

      if (url.startsWith('/')) {
        return `${origin}${url}`;
      }

      return url;
    },
    getxuanfeilist() {
      this.$http({
        method: 'get',
        url: 'xuanfeilist',
        data: { id: 1, page: 1 }
      }).then((res) => {
        const lang = localStorage.getItem('lang') || 'zh';
        const list = Array.isArray(res && res.data) ? res.data : [];
        this.datalist = list.map((item) => {
          const safeItem = item && typeof item === 'object' ? item : {};
          const rawFlag = typeof safeItem.flag === 'string' ? safeItem.flag : '';
          const parts = rawFlag ? rawFlag.split('|') : [];
          let localizedFlag = parts[0] || '';

          if (lang === 'en') {
            localizedFlag = parts[1] || localizedFlag;
          } else if (lang === 'ja') {
            localizedFlag = parts[2] || localizedFlag;
          } else if (lang !== 'zh') {
            localizedFlag = parts[3] || localizedFlag;
          }

          return {
            ...safeItem,
            flag: localizedFlag || 'California'
          };
        });
      });
    }
  },
  created() {
    this.getxuanfeilist();
  }
};
</script>

<style lang="less" scoped>
.sincere-home {
  min-height: 100vh;
  background: #000;
  color: #fff;
}

.home-nav {
  min-height: 86px;
  background: #1c1c1e;
}

::v-deep .home-nav .van-nav-bar {
  background: #1c1c1e;
}

::v-deep .home-nav .van-nav-bar__content {
  height: 76px;
}

::v-deep .home-nav .van-nav-bar__left,
::v-deep .home-nav .van-nav-bar__right {
  padding: 0 12px;
}

.nav-logo {
  width: 46px;
  height: 46px;
  object-fit: contain;
}

.nav-title {
  color: #e6b98a;
  font-size: 22px;
  font-weight: 700;
}

.nav-action-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.home-body {
  padding: 0 0 98px;
}

.banner-swipe {
  margin-bottom: 20px;
}

.banner-item,
.banner-image {
  width: 100%;
  height: 226px;
}

.banner-image {
  display: block;
  object-fit: cover;
  border-radius: 20px;
}

::v-deep .banner-swipe .van-swipe__indicators {
  bottom: 12px;
}

::v-deep .banner-swipe .van-swipe__indicator {
  width: 7px;
  height: 7px;
  margin: 0 4px;
  background: rgba(255, 255, 255, 0.45);
}

.notice-section,
.shortcut-section,
.section-title,
.dating-grid {
  padding: 0 12px;
}

.notice-container,
.shortcut-grid {
  border: 2px solid #766350;
  background: linear-gradient(90deg, rgba(37, 38, 43, 0.95), rgba(29, 30, 36, 0.95));
}

.notice-container {
  display: flex;
  align-items: center;
  height: 78px;
  padding: 0 18px;
  border-radius: 18px;
}

.notice-icon {
  width: 38px;
  height: 38px;
  margin-right: 14px;
  object-fit: contain;
}

.notice-marquee {
  flex: 1;
  overflow: hidden;
  color: #efc79b;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
}

.notice-track {
  display: inline-flex;
  min-width: max-content;
  animation: marquee 32s linear infinite;
}

.notice-track span {
  padding-right: 72px;
}

.more-btn {
  border: none;
  background: transparent;
  color: #efc79b;
  font-size: 20px;
  font-weight: 600;
  line-height: 1;
}

.shortcut-section {
  margin-top: 24px;
}

.shortcut-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  padding: 28px 14px 24px;
  border-radius: 12px;
}

.shortcut-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 132px;
  border: none;
  background: transparent;
  color: #efc79b;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
}

.shortcut-icon {
  width: 72px;
  height: 72px;
  margin-bottom: 16px;
  object-fit: contain;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 26px;
  height: 58px;
  background: linear-gradient(90deg, rgba(38, 39, 45, 0.96), rgba(48, 49, 55, 0.82));
}

.title-left {
  display: flex;
  align-items: center;
}

.title-line {
  width: 4px;
  height: 28px;
  margin: 0 16px 0 18px;
  background: #efc79b;
}

.title-text {
  color: #efb47c;
  font-size: 20px;
  font-weight: 700;
}

.secondary {
  padding-right: 18px;
  color: #a58871;
}

.dating-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: 24px;
}

.dating-card {
  position: relative;
  overflow: hidden;
  min-height: 338px;
  border: 4px solid #766350;
  border-radius: 18px;
  background: #15171d;
}

.dating-image {
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  margin: 4px;
  object-fit: cover;
}

.live-icon {
  position: absolute;
  left: 12px;
  top: 12px;
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.verified-tag {
  position: absolute;
  top: 22px;
  right: -28px;
  padding: 5px 42px;
  background: linear-gradient(90deg, #efcba7, #dcab76);
  color: #111;
  font-size: 18px;
  font-style: italic;
  font-weight: 800;
  transform: rotate(45deg);
}

.card-overlay {
  position: absolute;
  right: 4px;
  bottom: 4px;
  left: 4px;
  padding: 16px 12px 14px;
  background: rgba(0, 0, 0, 0.5);
}

.card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.vip-text {
  color: #e6b98a;
  font-size: 20px;
  font-weight: 800;
}

.location-tag {
  padding: 6px 14px;
  border-radius: 16px;
  background: linear-gradient(90deg, #efcba7, #dcab76);
  color: #4a4947;
  font-size: 18px;
  font-weight: 800;
}

.score-row {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.score-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  object-fit: contain;
}

.score-text {
  color: #fff;
  font-size: 24px;
  font-weight: 800;
}

.customer-service-btn {
  position: fixed;
  right: 20px;
  bottom: 148px;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 84px;
  height: 84px;
  border: none;
  border-radius: 50%;
  background: #ff2f34;
  box-shadow: 0 0 18px rgba(255, 66, 87, 0.55);
}

.customer-service-btn img {
  width: 38px;
  height: 38px;
  object-fit: contain;
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}
</style>
